import React, { useEffect } from "react";
import svg7 from "../../../../assets/svg/svg7.svg";
import svg33 from "../../../../assets/svg/svg33.svg";
import { Divider, Progress } from "antd";
import { useNavigate } from "react-router-dom";
import EvaluationReportsTable from "./EvaluationReportsTable";
import BreadCrumb from "../../../../layout/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../../../features/fetch/fetchSlice";

function EvaluationDetailList() {
  const navigate = useNavigate();
  const url = "evaluation/fetch_evaluations";
  const dispatch = useDispatch();
  const { activeObjEvaluation, data } = useSelector((state) => ({
    activeObjEvaluation: state.obj.activeObj["evaluation"],
    data: state.fetch.data[url] || [],
  }));



  async function fetchTableData() {
    await dispatch(
      fetchData({
        url: url,
        limit: null,
        start: 0,
        evaProjectId: activeObjEvaluation?.projectId,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);
  return (
    <>
      <BreadCrumb
        breadcrumbs={[
          { title: "Project Progress", path: "/rob/project-evaluations" },
          { title: `Progress Details ${data?.[0]?.projectName}` },
        ]}
      />
      <div className="white_card mt-[2.41rem]">
        <div className="text-[#0092CC] font-interSans font-[500] text-[.75rem]">
          {data?.[0]?.evaNumber}
        </div>
        <div className="form-add-h !text-[#050505] mt-[.63rem]">
          {data?.[0]?.evaName}
        </div>
        <div className="proj_desc mt-[.62rem]">{data?.[0]?.projectRemarks}</div>
        <div className="mt-[1.25rem] flex lg:flex-row flex-col gap-y-2 lg:items-center gap-x-[.62rem] w-full">
          <div className="flex items-center gap-x-1">
            <img src={svg7} alt="svg7" />
            <span className="forgot-text">{data?.[0]?.projectCountyName}</span>
          </div>

          <div className="flex items-center gap-x-1 ">
            <img src={svg33} alt="svg33" />
            <span className="forgot-text"> {data?.[0]?.projectAgencyName}</span>
          </div>

          <div className="flex  items-center flex-1 gap-x-[.62rem]">
            <span className="forgot-text lg:flex hidden">| Progress</span>
            <Progress
              strokeColor="#4FAD5B"
              className="lg:w-[30%] w-full"
              percent={data?.[0]?.projectCompletionRate}
            />
          </div>
        </div>

        <div className="mt-[2.44rem]">
          <Divider />
        </div>
        <EvaluationReportsTable />
      </div>
    </>
  );
}

export default EvaluationDetailList;
